export const SERVER_FAILURE_ERROR = 'Whoops seems like something went wrong. Please try again later';
export const SERVER_SUCCESS_UPDATE = 'Entry was successfully updated';
export const SERVER_SUCCESS_CREATE = 'Entry was successfully created';
export const SERVER_SUCCESS_DELETE = 'Entry was successfully deleted';
